import toast from "react-hot-toast";
import { useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const MEDICATION_QUERY_KEYS = [
  "longTermMedications",
  "acuteMedications",
  "paginatedAcuteMedications",
  "paginatedLongTermMedications",
];

// Stops (discontinues) a patient medication and refreshes the medication lists.
// Shared by the medication page and the CDM/PP/OCF medication-review panel.
export const useStopMedication = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  const stopMedication = async (id, stopReason) => {
    try {
      const axiosInstance = createAxiosInstance();
      await axiosInstance.post(`${tenantVal}/patientmedication/stop/${id}`, {
        stopReason,
      });
      toast.success("Medication has been stopped");
      MEDICATION_QUERY_KEYS.forEach((queryKey) =>
        queryClient.invalidateQueries({ queryKey: [queryKey] })
      );
    } catch (error) {
      toast.error(`Error stopping medication: ${error.message}`);
      console.error("Stop medication failed:", error);
    }
  };

  return { stopMedication };
};
